import { useEffect, useState, useRef } from "react";
import { useStateValue } from "../../shared/state/StateProviders";
import "../../shared/components/Header.css";
import { useNavigate } from "react-router-dom";
import snh_logo from "../../media/Logo.png";

import toast, { Toaster } from "react-hot-toast";

function Receptionistheader() {
  const [profile, setProfile] = useState(true);
  const [{ RIsLogin }, dispatch] = useStateValue();
  const [userdata, setuserdata] = useState({});
  let navigate = useNavigate();

  const [viewType, setViewType] = useState("unread");
  const [showNotification, setShowNotification] = useState(false);
  useEffect(() => {
    const handleClickOutsideNotification = (event) => {
      const notificationDropdown = document.getElementById(
        "notification_dropdown"
      );
      if (
        notificationDropdown &&
        !notificationDropdown.contains(event.target)
      ) {
        setShowNotification(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideNotification);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideNotification);
    };
  }, []);

  useEffect(() => {
    var Url = window.API_PREFIX + "admin/receptionistdetail";
    fetch(Url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data);
        if (data["status"] === "Block") {
          toast.error(data["message"]);
          localStorage.clear();
          navigate("/Receptionist");
          window.location.reload();
        } else if (data["status"] === "1") {
          dispatch({ type: "RLogin" });
          setuserdata({ ...data["data"] });
        }
      });
  }, [RIsLogin]);

  const [isFullScrVisible, setFullScrVisible] = useState(false);
  const fullScrStyle = {
    left: isFullScrVisible ? 0 : "",
  };

  const handleMenuClick2 = () => {
    setFullScrVisible(!isFullScrVisible);
  };

  const [isOpenn, setOpenn] = useState(false);

  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timerId = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timerId);
  }, []);

  const formatTime = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    const strTime = `${hours}:${minutes}:${seconds} ${ampm}`;
    return strTime;
  };

  function AcceptRequest(Requestindex) {
    var Url = window.API_PREFIX + "booking/approve_booking";
    // dispatch({
    //     type: 'StartLoad'
    // })
    fetch(Url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
        Id: Requestindex,
        clinicId: localStorage.getItem("clinicId"),
        loginAs: localStorage.getItem("LoginDetails"),
        receptionistId: localStorage.getItem("receptionistId"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data);
        // dispatch({
        //     type: 'StopLoad'
        // })
        if (data["status"] === "Block") {
          toast.error(data["message"]);
          localStorage.clear();
          navigate("/Receptionist");
          window.location.reload();
        } else if (data["status"] === "1") {
          getNotifications(false);
        }
      });
  }

  function RejectRequest(Requestindex) {
    // dispatch({
    //     type: 'StartLoad'
    // })
    var Url = window.API_PREFIX + "booking/reject_booking";
    fetch(Url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
        Id: Requestindex,
        clinicId: localStorage.getItem("clinicId"),
        loginAs: localStorage.getItem("LoginDetails"),
        receptionistId: localStorage.getItem("receptionistId"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data);
        // dispatch({
        //     type: 'StopLoad'
        // })
        if (data["status"] === "Block") {
          toast.error(data["message"]);
          localStorage.clear();
          navigate("/Receptionist");
          window.location.reload();
        } else if (data["status"] === "1") {
          getNotifications(false);
        }
      });
  }

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef1 = useRef(null);

  // Toggle dropdown when notification icon is clicked
  const toggleDropdown = (event) => {
    event.stopPropagation();
    setIsOpen(!isOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  //     ######################### Notification Section ###########################

  const [anchorEl, setAnchorEl] = useState(null);

  // const [AllMsg,setAllMsg] = useState([])
  const [GroupName, setGroupName] = useState("");
  // const [unreadcount,setunreadcount] = useState("")

  const [chatSocket, setChatSocket] = useState(null);
  const [webSocketInitialized, setWebSocketInitialized] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [totalUnseenNotification, setTotalUnseenNotification] = useState(0);
  // console.log("notification", notifications)
  function getNotifications(showAlert) {
    var Url = window.API_PREFIX + "admin/viewreceptionistnotification";
    fetch(Url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
        clinicId: localStorage.getItem("clinicId"),
        loginAs: localStorage.getItem("LoginDetails"),
        receptionistId: localStorage.getItem("receptionistId"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data["status"] === "Block") {
          toast.error(data["message"]);
          localStorage.clear();
          navigate("/Receptionist");
          window.location.reload();
        } else if (data["status"] === "1") {
          setNotifications(data["notification"]);

          const unseenNotification = data["notification"].filter(
            (item) => item.IsSeen === false
          ).length;

          if (unseenNotification > 0) {
            const message = data["notification"][0]["Message"];

            // if (showAlert == true && message) {
            //   alert(message);
            // }

            dispatch({ type: "NewNotification" });
          }
          setTotalUnseenNotification(unseenNotification);
        }
      });
  }

  useEffect(() => {
    getNotifications(false);
  }, [anchorEl]);

  useEffect(() => {
    if (!webSocketInitialized) {
      setGroupName("receptionist_notify");

      const socket = new WebSocket(window.WEBSOC + "ws/ReceptionistNotify/");
      socket.onopen = () => {
        console.log("WebSocket connection opened");
        setWebSocketInitialized(true);
      };
      socket.onmessage = function (e) {
        let received_data_as_object = e["data"];
        // console.log(received_data_as_object)

        if (received_data_as_object.split("_")[0] === "Reload") {
          getNotifications(true);
        }
        //   const data = JSON.parse(e.data);
        // setChatLog((prevChatLog) => prevChatLog + e.data + '\n');
      };

      socket.onclose = function (e) {
        console.error("Chat socket closed unexpectedly");
        setWebSocketInitialized(false);
      };
      setChatSocket(socket);
      // return () => {
      //     socket.close();
      // };
    }
  }, [GroupName]);

  function handleSeen(notification) {
    var Url = window.API_PREFIX + "admin/get_seen";
    fetch(Url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
        id: notification.id.toString(),
        loginAs: localStorage.getItem("LoginDetails"),
        receptionistId: localStorage.getItem("receptionistId"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data["status"] === "1") {
          getNotifications(false);
          if (data["status"] === "Block") {
            toast.error(data["message"]);
            localStorage.clear();
            navigate("/Receptionist");
            window.location.reload();
          } else if (notification.Type === "Order") {
            setAnchorEl(null);
            navigate(`/administration/OrderDetail/${notification.Id_All_Type}`);
          }
        }
      });
  }

  function handleDelete(id) {
    var Url = window.API_PREFIX + "admin/get_delete";
    fetch(Url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
        Id: id.toString(),
        loginAs: localStorage.getItem("LoginDetails"),
        receptionistId: localStorage.getItem("receptionistId"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data["status"] === "Block") {
          toast.error(data["message"]);
          localStorage.clear();
          navigate("/Receptionist");
          window.location.reload();
        } else if (data["status"] === "1") {
          getNotifications(false);
        }
      });
  }

  function handleRead() {
    var Url = window.API_PREFIX + "admin/get_allseen";
    fetch(Url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
        loginAs: localStorage.getItem("LoginDetails"),
        receptionistId: localStorage.getItem("receptionistId"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data["status"] === "Block") {
          toast.error(data["message"]);
          localStorage.clear();
          navigate("/Receptionist");
          window.location.reload();
        } else if (data["status"] === "1") {
          getNotifications(false);
        }
      });
  }

  function getTimeDifference(timestamp) {
    timestamp = timestamp.replace(/\.$/, "");
    const currentTime = new Date(); // Current date and time
    const previousTime = new Date(timestamp); // Replace '-' with '/' for broader browser compatibility

    const timeDifference = currentTime - previousTime;

    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30); // Approximation, not precise
    const years = Math.floor(months / 12); // Approximation, not precise

    if (seconds < 60) {
      return seconds + " seconds ago";
    } else if (minutes < 60) {
      return minutes + " minutes ago";
    } else if (hours < 24) {
      return hours + " hours ago";
    } else if (days < 30) {
      return days + " days ago";
    } else if (months < 12) {
      return months + " months ago";
    } else {
      return years + " years ago";
    }
  }

  const notificationstyle = (isSeen) => {
    return {
      backgroundColor: isSeen ? "white" : "#d7d5d5",
      marginTop: "10px",
      borderRadius: "10px",
    };
  };

  const [bar, setbar] = useState(false);

  const barstyle = {
    right: bar ? 0 : "",
  };

  const handleMenuClick = () => {
    setbar(!bar);
  };

  const notificationSidebarRef = useRef(null);

  useEffect(() => {
    const handleBodyClick = (event) => {
      if (
        notificationSidebarRef.current &&
        !notificationSidebarRef.current.contains(event.target)
      ) {
        setbar(false); // Close the sidebar when clicking outside
      }
    };

    window.addEventListener("click", handleBodyClick);

    return () => {
      window.removeEventListener("click", handleBodyClick);
    };
  }, [notificationSidebarRef]);

  const handleBellClick = (event) => {
    event.stopPropagation();
    handleMenuClick();
  };

  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setProfile(true); // Close the profile if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <header className="container-fuild">
      {/* <div className="" id="full-scr" style={fullScrStyle}>
        <div className='d-flex justify-content-between align-items-center' style={{ borderBottom: '1px solid grey' }}>
          <img src={snh_logo} style={{ width: '50%' }} ></img>
          <div onClick={handleMenuClick2}>
            <Hamburger
              toggled={isOpenn}
              toggle={setOpenn}
              size={30}
              color='black'
            />
          </div>
        </div>
        <div className='mt-2 sidebar_div_two'>
          <div onClick={() => {
            navigate('/receptionist/dashboard')
            setFullScrVisible(false)
          }}>Dashboard</div>

          <div onClick={() => {
            navigate('/receptionist/schedule-timing')
            setFullScrVisible(false)
          }}>Schdule Timing</div>

          <div onClick={() => {
            navigate('/cli/doctorchangepassword')
            setFullScrVisible(false)
          }}>Change Password</div>
        </div>
      </div> */}

      <div className=" header_main_division">
        {/* <div className='btn_bar' onClick={handleMenuClick2}>
          <Hamburger
            toggled={isOpenn}
            toggle={setOpenn}
            size={30}
            color='black'
          />
        </div> */}

        <div className="header_logo_main_division">
          <img
            className="header_logo_division"
            src={snh_logo}
            alt="123"
            onClick={() => {
              navigate("/receptionist/dashboard");
            }}
          />
        </div>

        <div className="header_center_main_division">
          <div className="d-flex align-items-center ">
            <i class="fa-regular fa-clock clock_icon"></i>
            <div className="live_clock">{formatTime(time)}</div>
          </div>
        </div>

        {RIsLogin ? (
          <div
            className="header_contact_profile_main_division"
            ref={dropdownRef}
          >
            <div className="notification_container">
              <div
                onMouseEnter={() => setShowNotification(true)}
                class="dropdown profile-nav-item"
              >
                <div
                  class="dropdown-bs-toggle custom-toggle show"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-bs-auto-close="outside"
                  style={{ top: 2 }}
                >
                  <div class="menu-profile">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-bell"
                    >
                      <path d="M10.268 21a2 2 0 0 0 3.464 0"></path>
                      <path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"></path>
                    </svg>
                    <span
                      style={{
                        padding:
                          totalUnseenNotification?.length > 1
                            ? "2px 3px 9px 6px"
                            : "3px 3px 9px 8px",
                      }}
                      class="custom-Notification-cricle"
                    >
                      {totalUnseenNotification}
                    </span>
                  </div>
                </div>
                <div
                  id="notification_dropdown"
                  onMouseLeave={() => setShowNotification(false)}
                  class={`dropdown-menu ${showNotification ? "show" : ""}`}
                  style={{ minWidth: 340 }}
                >
                  <div class="dropdown-header d-flex flex-column align-items-center"></div>
                  <div class="dropdown-body">
                    <div class="dropdown-head custom-bg-tag custom-text-tag  bg-pattern rounded-top">
                      <div class="p-3">
                        <div class="align-items-center row">
                          <div class="col">
                            <h6 class="m-0 fs-16 fw-semibold text-white">
                              {" "}
                              Notifications{" "}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>

                    <ul
                      class="nav nav-pills mt-3 gap-3"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li class="nav-item" role="presentation">
                        <button
                          onClick={() => {
                            setViewType("unread");
                          }}
                          class={`nav-link ${
                            viewType === "unread" ? "active" : ""
                          }`}
                          id="pills-profile-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-profile"
                          type="button"
                          role="tab"
                          aria-controls="pills-profile"
                          aria-selected="false"
                        >
                          Unread
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          onClick={() => {
                            setViewType("read");
                          }}
                          class={`nav-link ${
                            viewType === "read" ? "active" : ""
                          } `}
                          id="pills-home-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-home"
                          type="button"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected="true"
                        >
                          Read
                        </button>
                      </li>
                    </ul>

                    {viewType === "read" && (
                      <div
                        class="pe-2 mt-3"
                        style={{ maxHeight: 400, overflow: "hidden auto" }}
                      >
                        {notifications?.filter((er) => er?.IsSeen)?.length >
                        0 ? (
                          notifications
                            ?.filter((er) => er?.IsSeen)
                            ?.map((notification) => {
                              return (
                                <div class="custom-border mb-2 text-reset notification-item d-block dropdown-item position-relative">
                                  <div class="pt-2  d-flex align-items-center gap-2">
                                    <div class="avatar-xs"> </div>
                                    <div
                                      class=" flex-1"
                                      onClick={() =>
                                        handleSeen(notification, "appointment")
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      <div class="">
                                        {notification.Title && (
                                          <h6
                                            class="mt-0 mb-2 lh-base"
                                            style={{
                                              inlineSize: 200,
                                              fontWeight: 700,
                                              textWrapMode: "wrap",
                                            }}
                                          >
                                            {notification.Title}
                                          </h6>
                                        )}
                                        <h6
                                          class="mt-0 mb-2 lh-base"
                                          style={{
                                            inlineSize: 200,
                                            textWrapMode: "wrap",
                                          }}
                                        >
                                          {notification.Message}
                                        </h6>
                                      </div>
                                    </div>
                                    <div class="px-2 fs-15">
                                      <svg
                                        onClick={() =>
                                          handleDelete(notification.id)
                                        }
                                        style={{ cursor: "pointer" }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        id="Layer_1"
                                        data-name="Layer 1"
                                        viewBox="0 0 24 24"
                                        width="18"
                                        height="18"
                                      >
                                        <path d="m16.707,8.707l-3.293,3.293,3.293,3.293-1.414,1.414-3.293-3.293-3.293,3.293-1.414-1.414,3.293-3.293-3.293-3.293,1.414-1.414,3.293,3.293,3.293-3.293,1.414,1.414Zm7.293,3.293c0,6.617-5.383,12-12,12S0,18.617,0,12,5.383,0,12,0s12,5.383,12,12Zm-2,0c0-5.514-4.486-10-10-10S2,6.486,2,12s4.486,10,10,10,10-4.486,10-10Z" />
                                      </svg>
                                    </div>
                                  </div>
                                  <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                    <span>
                                      <i class="mdi mdi-clock-outline"></i>{" "}
                                      {getTimeDifference(notification.Datetime)}
                                    </span>
                                  </p>
                                </div>
                              );
                            })
                        ) : (
                          <p>No Notification Found</p>
                        )}
                      </div>
                    )}
                    {viewType === "unread" && (
                      <div
                        class="pe-2 mt-3"
                        style={{ maxHeight: 400, overflow: "hidden auto" }}
                      >
                        {notifications?.filter((er) => !er?.IsSeen)?.length >
                        0 ? (
                          notifications
                            ?.filter((er) => !er?.IsSeen)
                            ?.map((notification) => {
                              return (
                                <div class="custom-border mb-2 text-reset notification-item d-block dropdown-item position-relative">
                                  <div class="pt-2  d-flex align-items-center gap-2">
                                    <div class="avatar-xs"> </div>
                                    <div
                                      class=" flex-1"
                                      onClick={() =>
                                        handleSeen(notification, "appointment")
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      <div class="">
                                        {notification.Title && (
                                          <h6
                                            class="mt-0 mb-2 lh-base"
                                            style={{
                                              inlineSize: 200,
                                              fontWeight: 700,
                                              textWrapMode: "wrap",
                                            }}
                                          >
                                            {notification.Title}
                                          </h6>
                                        )}
                                        <h6
                                          class="mt-0 mb-2 lh-base"
                                          style={{
                                            inlineSize: 200,
                                            textWrapMode: "wrap",
                                          }}
                                        >
                                          {notification.Message}
                                        </h6>
                                      </div>
                                    </div>
                                    <div class="px-2 fs-15">
                                      <svg
                                        onClick={() =>
                                          handleDelete(notification.id)
                                        }
                                        style={{ cursor: "pointer" }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        id="Layer_1"
                                        data-name="Layer 1"
                                        viewBox="0 0 24 24"
                                        width="18"
                                        height="18"
                                      >
                                        <path d="m16.707,8.707l-3.293,3.293,3.293,3.293-1.414,1.414-3.293-3.293-3.293,3.293-1.414-1.414,3.293-3.293-3.293-3.293,1.414-1.414,3.293,3.293,3.293-3.293,1.414,1.414Zm7.293,3.293c0,6.617-5.383,12-12,12S0,18.617,0,12,5.383,0,12,0s12,5.383,12,12Zm-2,0c0-5.514-4.486-10-10-10S2,6.486,2,12s4.486,10,10,10,10-4.486,10-10Z" />
                                      </svg>
                                    </div>
                                  </div>
                                  <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                    <span>
                                      <i class="mdi mdi-clock-outline"></i>{" "}
                                      {getTimeDifference(notification.Datetime)}
                                    </span>
                                  </p>
                                </div>
                              );
                            })
                        ) : (
                          <p>No Notification Found</p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="header_contact_main_division">
              <div
                onClick={() => {
                  setProfile(!profile);
                }}
                className="header_profile_main_division"
              >
                <div className="header_profile_image_division">
                  <img
                    className=" header_profile_image"
                    src={userdata?.ProfilePic}
                  ></img>
                </div>
                <p className="header_profile_header_name">{userdata?.Name}</p>
                <div>
                  <i
                    class={
                      profile
                        ? "fa-solid fa-chevron-down ms-2"
                        : "fa-solid fa-chevron-up header_profile_arrow_up_icon ms-2"
                    }
                  ></i>
                </div>
                {!profile ? (
                  <div className="header_profile_division">
                    <div className="header_profile_division_header">
                      <div className="header_profile_header_profile_image_division">
                        <img
                          className="header_profile_header_profile_image"
                          src={userdata?.ProfilePic}
                        ></img>
                      </div>
                      <div>
                        {/* <p className='header_profile_header_name'>{userdata['Name']}</p> */}
                        <p className="header_profile_header_name">
                          {userdata?.Name}
                        </p>
                      </div>
                    </div>
                    <div
                      className="header_profile_list"
                      onClick={() => {
                        navigate("/receptionist/dashboard");
                      }}
                    >
                      <i class="fa-solid fa-table-columns me-2"></i> Dashboard
                    </div>

                    <div
                      className="header_profile_list"
                      onClick={() => {
                        navigate("/receptionist/receptionistchangepassword");
                      }}
                    >
                      <i class="fa-solid fa-lock me-2"></i> Change Password
                    </div>
                    <div
                      className="header_profile_list"
                      onClick={() => {
                        localStorage.clear();

                        dispatch({ type: "RLogout" });

                        navigate("/Receptionist");
                      }}
                    >
                      <i class="fa-solid fa-right-from-bracket me-2"></i> Log
                      Out
                    </div>
                  </div>
                ) : null}
              </div>
            </div>

            {/* <div>
              <IconButton
                aria-label="more"
                id="long-button"
                aria-haspopup="true"
              >
                <Badge badgeContent={totalUnseenNotification} color="primary">
                  <i class="fa-solid fa-bell "></i>
                </Badge>
              </IconButton>
            </div>

            <div style={{ marginLeft: "20px" }}>
              <div
                className="notification_sidebar"
                style={barstyle}
                ref={notificationSidebarRef}
              >
                <div className="notificitaion_title_div">
                  <div className="doctor_header_notification_title">
                    Notifications
                  </div>
                  <div
                    onClick={handleRead}
                    style={{ borderBottom: "1px solid grey", color: "white" }}
                  >
                    Clear All
                  </div>
                  <div
                    className="icon_div"
                    onClick={() => {
                      setbar(false);
                    }}
                  >
                    <i
                      class="fa-solid fa-xmark"
                      style={{ color: "black" }}
                      onClick={() => {
                        setbar(false);
                      }}
                    ></i>
                  </div>
                </div>
                <div
                  className="notification_main_div"
                  style={{
                    marginTop: "50px",
                    overflowY: "scroll",
                    backgroundColor: "white",
                    maxHeight: "100vh",
                  }}
                >
                  {notifications.map((notification) => {
                    if (notification.Type == "PendingAppointment")
                      return (
                        <MenuItem
                        >
                          <div
                            className="mt-2"
                            style={{ whiteSpace: "pre-wrap" }}
                            onClick={() => handleSeen(notification)}
                          >
                            <div className="doctor_header_notification_card_first_div">
                              <div>
                                <img
                                  className="doctor_header_notification_patient_image"
                                  onClick={() => {
                                    navigate(
                                      "/receptionist/clientprofile/" +
                                      notification.User
                                    );
                                  }}
                                  src={notification.img}
                                ></img>
                              </div>
                              <div className="mx-2">
                                <div className="doctor_header_notification_patient_name">
                                  {notification.Message}
                                </div>
                              </div>
                            </div>
                            <div className="doctor_header_notification_btn_main_div">
                              <button
                                className="btn doctor_header_notification_accept_btn mt-2  "
                                onClick={() => {
                                  AcceptRequest(notification.Id_All_Type);
                                }}
                              >
                              
                                Accept
                              </button>
                              <button
                                className="btn doctor_header_notification_cancel_btn mt-2 "
                                onClick={() => {
                                  RejectRequest(notification.Id_All_Type);
                                }}
                              >
                      
                                Reject
                              </button>
                            </div>
                            <div className="doctor_header_notification_time">
                              {getTimeDifference(notification.Datetime)}
                            </div>
                          </div>
                          <IconButton
                            aria-label="delete"
                            size="small"
                            onClick={() => handleDelete(notification.id)}
                          >
                            <Close fontSize="small" />
                          </IconButton>
                        </MenuItem>
                      );
                    else {
                      return (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            borderBottom: "1px solid #d5d5d5",
                            padding: "5px",
                          }}
                        >
                          <MenuItem
                            style={notificationstyle(notification.IsSeen)}
                          >
                            <div
                              style={{ whiteSpace: "pre-wrap" }}
                              onClick={() => handleSeen(notification)}
                            >
                              <div>
                                <img
                                  className="doctor_header_notification_patient_image"
                                  onClick={() => {
                                    navigate(
                                      "/receptionist/clientprofile/" +
                                      notification.User
                                    );
                                  }}
                                  src={notification.img}
                                ></img>
                              </div>
                              <div className="text_notification">
                                {notification.Title}
                              </div>
                              <div className="text_notification">
                                {notification.Message}
                              </div>
                              <div className="text_notification">
                                {getTimeDifference(notification.Datetime)}
                              </div>
                            </div>
                            <IconButton
                              aria-label="delete"
                              size="small"
                              onClick={() => handleDelete(notification.id)}
                            >
                              <Close fontSize="small" />
                            </IconButton>
                          </MenuItem>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            </div> */}
          </div>
        ) : null}
      </div>
    </header>
  );
}

export default Receptionistheader;
